
import moment from 'moment';


export default function convertDate(currentDate,item,messages){
    const creationLocaldate = moment(item.date, "YYYY-MM-DD HH:mm:ss Z")._d
  const currentMomentDate = moment(creationLocaldate)

  const diffOfDates = moment.duration(currentDate.diff(currentMomentDate));
  const days = diffOfDates.asDays();

  let dateFormat = ""
  if(days === 1){
    dateFormat = Math.round(days) + messages['app.investmentIdeas.day'];
  }
  else if (days >1) {
    dateFormat = Math.round(days) + messages['app.investmentIdeas.days'];
  }
  else {
    const hours = Math.round(diffOfDates.asHours());
    if (hours === 24)
      dateFormat = hours + messages['app.investmentIdeas.day'];
    else if (hours === 1)
      dateFormat = hours + messages['app.investmentIdeas.hour'];
    else if (hours > 0)
      dateFormat = hours + messages['app.investmentIdeas.hours'];
    else {
      const minutes = Math.round(diffOfDates.asMinutes());
      if (minutes === 60)
        dateFormat = minutes + messages['app.investmentIdeas.hour'];
      else if (minutes === 1)
        dateFormat = minutes + messages['app.investmentIdeas.min'];
      else if (minutes > 0)
        dateFormat = minutes + messages['app.investmentIdeas.mins'];
      else {
        const seconds = Math.round(diffOfDates.asSeconds());
        if (seconds === 60)
          dateFormat = seconds + messages['app.investmentIdeas.min'];
        else if (seconds === 1 || seconds <= 0)
          dateFormat = 1 + messages['app.investmentIdeas.sec'];
        else
          dateFormat = seconds + messages['app.investmentIdeas.secs'];
      }
    }
  }

  item.date = dateFormat
  return item;


}